export default __webpack_public_path__ + "static/media/scw-grid-12.afdf6353.svg";